<template>
  <div class="MappingQuestionsContainer">
    <h2 class="Heading">
      Zapier Configuration
    </h2>
    <section>
      <rmp-input
        v-model.trim="endpoint"
        :required="true"
        :error="endpointValidationError"
        :manual-validate="shouldValidateEndpoint"
        label="Custom Webhook URL"
      />
      <rmp-input
        v-if="sharedSecret"
        v-model="sharedSecret"
        :disabled="true"
        label="Secret"
      />
      <div class="Footer u-flex u-flex-spaceBetween">
        <button
          class="Button Button--green-outline"
          @click="$emit('zapier-options:back-navigation')"
        >
          Back
        </button>
        <div class="">
          <span class="StepNumber">3/3</span><button
            class="Button Button--green"
            :disabled="shouldValidateEndpoint"
            @click="handleSubmitIntegration"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import RmpInput from '@rmpenterprise/form-input';

export default {
  components: {
    RmpInput,
  },
  props: {
    integration: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      endpoint: null,
      sharedSecret: null,
    };
  },
  computed: {
    buttonText() {
      return this.integration.id ? 'Update Integration' : 'Create Integration';
    },
    endpointValidationError() {
      return this.shouldValidateEndpoint ? { errors: [{ message: 'Endpoint is required' }] } : {};
    },
    shouldValidateEndpoint() {
      return this.endpoint === '';
    },
  },
  watch: {
    'integration.endpoint': {
      immediate: true,
      handler(endpoint) {
        if (endpoint) this.endpoint = endpoint;
      },
    },
    'integration.shared_secret': {
      immediate: true,
      handler(secret) {
        if (secret) this.sharedSecret = secret;
      },
    },
  },
  methods: {
    handleSubmitIntegration() {
      if (this.endpoint === null) {
        this.endpoint = '';
        return;
      }
      this.$emit('zapier-options:submit', { endpoint: this.endpoint, sharedSecret: this.sharedSecret });
    },
  },
};
</script>
<style scoped lang="scss">
.MappingQuestionsContainer {
  border: 1px solid #E3E3E3;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0 13px 29px 0 rgba(0,0,0,0.11);
  padding-bottom: 25px;

.Heading {
    padding: 21px 30px;
    border-bottom: 1px solid lightgray;
    margin: 0;
  }
}
.StepNumber {
  margin-right: 5px;
}
</style>
